import { StyleSheet } from 'aphrodite';
import { brandSecondary, mention, nameCircles, white } from '../../../styles/colors';

export const s = StyleSheet.create({
	root: {
		backgroundColor: white,
		borderRadius: 3,
		border: `1px solid ${nameCircles}`,
		boxShadow: '0 0 6px 0 rgba(139,139,139,0.20)',
		overflow: 'hidden',
		paddingLeft: 20,
		paddingRight: 20,
	},
	header: {
		width: '100%',
	},
	badge: {
		width: 60,
		height: 60,
		borderRadius: '50%',
		backgroundColor: mention,
		color: brandSecondary,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	badgeInner: {
		width: 34,
		height: 34,
		borderRadius: '50%',
		backgroundColor: 'white',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		border: `2px solid ${brandSecondary}`,
		':has(*) > svg': {
			width: 20,
			height: 20,
			fill: 'white',
		},
	},
});
